
import moment from 'moment'

var table = {
    name: 'realestate.product_transaction_view',
    list_views: {
        filters: [

        ],
        sorts: {

        },
        columns: [
            'id',
            'address',
            'buyer_name',
            'price_bought',
            'seller_name'
        ]
    },
    input_view: {
        forms: [
            // {
            //     col: 'label_1',
            //     type: 'label',
            //     value: null, // default value
            //     defaultValue: 'Mô tả nhu cầu chi tiết',
            //     required: false,
            //     visible: true,
            //     colspan:12
            // },

            // {
            //     col: 'client_bought_id',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 4
            // },

            // {
            //     col: 'client_sold_id',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 4
            // },

            // {
            //     col: 'price_bought',
            //     type: 'multi-select',
            //     value: null, 
            //     required: false,
            //     visible: true,
            //     colspan: 4
            // }
        ]
    },
    columns: {
        id: {
            'name': 'id',
            'type': 'Id',
            'alias': 'ID',
        },
        product_id: {
            'name': 'product_id',
            'type': 'number',
            'alias': 'Mã sản phẩm',
        },
        client_bought_id: {
            'name': 'buyer_name',
            'type': 'text',
            'alias': 'Tên khách hàng mua',            
        },
        client_sold_id: {
            'name': 'seller_name',
            'type': 'text',
            'alias': 'Tên khách hàng bán',            
        },
        notes: {
            'name': 'address',
            'type': 'text',
            'alias': 'Địa chỉ'
        },
        price_bought: {
            'name': 'price_bought',
            'type': 'number',
            'alias': 'Giá mua',            
        },
        created_at: {
            'name': 'created_at',
            'type': 'date',
            'alias': 'Ngày giao dịch'
        },
        created_by: {
            'name': 'created_by',
            'type': 'text',
            'alias': 'Người tạo'
        },
        notes: {
            'name': 'notes',
            'type': 'text',
            'alias': 'Ghi chú'
        }
    }
}

export default {
    table_name: table.name,
    filter_orders: table.filter_orders,
    list_views: table.list_views,
    input_view: table.input_view,
    columns: table.columns
}